<div class="flex-container mt-3">
    <div cdkDropListGroup class="row">
        <div class="col pr-4">
            <h5>Usuarios</h5>
            <div class="list-group">
                <button *ngFor="let user of users" type="button" [ngClass]="{'active' : active(user)}" class="list-group-item list-group-item-action" (click)="updateUserSelection(user)">{{user.Email}}</button>
            </div>
        </div>
        <div class="col">
            <h5>Roles Asignados</h5>
            <div cdkDropList [cdkDropListData]="asigRoles" class="cdk-list" (cdkDropListDropped)="drop($event)">
                <div class="cdk-box" *ngFor="let role of asigRoles" cdkDrag>{{role.Name}}</div>
            </div>
        </div>
        <div class="col-1 d-flex align-items-center">
            <div>
                <button type="button" class="btn btn-outline-secondary border-0" (click)="setAllRoles()">
                    <fa-icon class="fa" icon="arrow-left"></fa-icon>
                </button>
                <button type="button" class="btn btn-outline-secondary border-0" (click)="unsetAllRoles()">
                    <fa-icon class="fa" icon="arrow-right"></fa-icon>
                </button>
            </div>
        </div>
        <div class="col">
            <h5>Roles Disponibles</h5>
            <div cdkDropList [cdkDropListData]="disRoles" class="cdk-list" (cdkDropListDropped)="drop($event)">
                <div class="cdk-box" *ngFor="let role of disRoles" cdkDrag>{{role.Name}}</div>
            </div>
        </div>
    </div>
</div>